import { Star, Heart, Layers, Link2 as LinkIcon, Navigation2, MapPin } from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const FALLBACK_IMG = 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&q=75';

export const GoogleGBadge = ({ size = 6 }) => (
  <span className={`relative inline-flex items-center justify-center w-${size} h-${size}`}>
    <Star className={`w-${size} h-${size} fill-amber-400 text-amber-400`} />
    <span className="absolute text-[8px] font-black text-white leading-none" style={{ top: size === 5 ? '6px' : '7px' }}>G</span>
  </span>
);

export const RepostIcon = ({ className = 'w-3.5 h-3.5' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 1l4 4-4 4" /><path d="M3 11V9a4 4 0 014-4h14" /><path d="M7 23l-4-4 4-4" /><path d="M21 13v2a4 4 0 01-4 4H3" />
  </svg>
);

export const InstagramSvg = () => (
  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg>
);

export const WhatsAppSvg = () => (
  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" /></svg>
);

export const LinkedInSvg = () => (
  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
);

/**
 * DirectionsPlaceholder — Shared "no image" fallback showing a directions link.
 * Used by Discover, Search, and Post variants when no photo is available.
 */
export const DirectionsPlaceholder = ({ name, location, height = 'h-44', testId = '' }) => {
  const mapQuery = `${name || ''} ${location || ''}`.trim();
  return (
    <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapQuery)}`}
      target="_blank" rel="noopener noreferrer"
      className={`relative ${height} bg-gradient-to-br from-slate-100 via-slate-50 to-orange-50 flex flex-col items-center justify-center cursor-pointer hover:from-slate-200 hover:to-orange-100 transition-all`}
      data-testid={`directions-${testId}`}>
      <div className="w-12 h-12 rounded-full bg-[#FF6B35]/10 flex items-center justify-center mb-2">
        <Navigation2 className="w-6 h-6 text-[#FF6B35]" />
      </div>
      <p className="text-sm font-bold text-gray-800">{name}</p>
      {location && <p className="text-xs text-gray-500 mt-0.5 flex items-center gap-1"><MapPin className="w-3 h-3" />{location}</p>}
      <div className="mt-2 flex items-center gap-1 px-3 py-1.5 bg-[#FF6B35] text-white rounded-full text-xs font-semibold">
        <Navigation2 className="w-3.5 h-3.5" /> Get Directions
      </div>
    </a>
  );
};

export function timeAgo(dateStr) {
  try {
    const diff = Date.now() - new Date(dateStr).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'now';
    if (mins < 60) return `${mins}m`;
    const hrs = Math.floor(mins / 60);
    if (hrs < 24) return `${hrs}h`;
    const days = Math.floor(hrs / 24);
    if (days < 7) return `${days}d`;
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch { return ''; }
}

export function buildShareHandler(name, venue, shareUrl) {
  return async (platform) => {
    const caption = `${name}${venue ? ` at ${venue}` : ''} — Discovered on FoodQuest!`;
    const encoded = encodeURIComponent(caption);
    const encodedUrl = encodeURIComponent(shareUrl);
    try {
      switch (platform) {
        case 'instagram':
          if (navigator.share) { await navigator.share({ title: name, text: caption, url: shareUrl }); }
          else window.open('https://www.instagram.com/', '_blank');
          break;
        case 'whatsapp': window.open(`https://wa.me/?text=${encoded}%20${encodedUrl}`, '_blank'); break;
        case 'linkedin': window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`, '_blank'); break;
        case 'copy':
          try {
            await navigator.clipboard.writeText(`${caption}\n${shareUrl}`);
          } catch {
            // Fallback for clipboard permission denied
            const ta = document.createElement('textarea');
            ta.value = `${caption}\n${shareUrl}`;
            ta.style.cssText = 'position:fixed;left:-9999px';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
          }
          break;
        default: break;
      }
      return { success: true, platform };
    } catch {
      return { success: false, platform };
    }
  };
}
